<template>
    <div class="">
        <CCard class="p-2">
            <div class="mb-3 d-flex justify-content-between align-items-center">
                <div class="d-flex">
                    <input type="text" class="form-control me-2" v-model="searchQuery" placeholder="Search by Package..." style="max-width: 300px" @keyup.enter="currentPage = 1" />
                </div>
    
                <CButton class="bg-007CEF text-white" @click="showAddModal = true">
                    Add Package
                </CButton>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover">
                    <thead class="" style="background: var(--Other-Light-Grey, #F9F9F9);">
                        <tr>
                            <th>#</th>
                            <th>Image</th>
                            <th>Package Name</th>
                            <th>Course Date & Time</th>
                            <th>Description</th>
                            <th>Price</th>
                            <th>Discount</th>
                            <th>No Of Student</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in paginatedItems" :key="item.ID">
                            <td>{{ index + 1 + (currentPage - 1) * perPage }}</td>
                            <td><img :src="item.PicturePath" width="50px" /></td>
                            <td>{{ item.Title }}</td>
                            <td>{{ item.DateCourse | moment("DD-MM-YYYY") }} - {{ item.TimeCourse }}</td>
                            <td v-html="item.Description"></td>
                            <td>{{ item.Price }}</td>
                            <td>{{ item.Discount }}</td>
                            <td>{{ item.NoOfStudent }}</td>
                            <td class="text-center d-flex">
    
                                <CButton class="custom-border-grey me-2 ml-2" @click="editItem(item)"><img src="../assets/img/edit 2.png" width="20px" /></CButton>
                                <CButton class="custom-border-danger ml-2" @click="OpenDelete(item)"><img src="../assets/img/trash.png" width="20px" /></CButton>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
    
    
    
            <!-- Pagination -->
            <nav>
                <ul class="pagination justify-content-center">
                    <li class="page-item" :class="{ disabled: currentPage === 1 }">
                        <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">Previous</a>
                    </li>
                    <li class="page-item" v-for="page in totalPages" :key="page" :class="{ active: currentPage === page }">
                        <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
                    </li>
                    <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                        <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">Next</a>
                    </li>
                </ul>
            </nav>
    
            <!-- Custom Popup Modal -->
            <div v-show="showAddModal" class="popup-all backdrop-all">
                <div class="popup-all2 p-4 custom-scroll-y" style="max-height: 90vh; overflow-y: auto;">
                    <CRow class="align-items-center mb-3">
                        <div style="width:100%" class="text-right">
                            <img src="../assets/img/close.png" style="max-width: 30px; cursor: pointer;" @click="closeModal" />
                        </div>
                    </CRow>
    
                    <h4 class="mb-4">Add Package</h4>
    
                    <!-- File Upload Section -->
                    <div class="mb-3 border border-dashed rounded p-4 text-center">
                        <div><i class="bi bi-upload" style="font-size: 24px;"></i></div>
                        <p class="mb-2">Choose a file or drag & drop it here</p>
                        <p class="text-muted">PNG, JPG, or JPEG formats, up to 10 MB</p>
                        <input type="file" class="form-control d-none" ref="fileInput" @change="handleFile" />
                        <button class="btn btn-outline-secondary" @click="$refs.fileInput.click()">Browse File</button>
    
                        <!-- ✅ Image Preview -->
                        <div v-if="imagePreview" class="mt-3">
                            <img :src="imagePreview" alt="Preview" style="max-width: 100%; max-height: 200px; border-radius: 10px;" />
                        </div>
                    </div>
    
                    <!-- Form Fields -->
                    <div class="row">
                        <div class="col-md-6 mb-3">
                            <label>Package Name</label>
                            <!-- <input type="text" class="form-control" v-model="newPackage.name" /> -->
                            <select class="form-control" v-model="newPackage.id" @change="onCourseChangePackage">
                                                    <option disabled value="">Select Package</option>
                                                    <option v-for="course in packageNameOptions" :key="course.value" :value="course.value">
                                                        {{ course.label }}
                                                    </option>
                                                    <option value="__new__">+ Add New Package</option>
                                                    </select>
                            <!-- <p>Selected Package ID: {{ newPackage.id }}</p> -->
                        </div>
    
                        <div class="col-md-6 mb-3">
                            <label>Number of Students</label>
                            <input type="text" class="form-control" v-model="newPackage.students" />
                            <!-- <select class="form-control" v-model="newPackage.students">
                              <option disabled value="">Select</option>
                              <option v-for="n in 30" :key="n">{{ n }}</option>
                            </select> -->
                        </div>
    
                        <div class="col-md-6 mb-3">
                            <label>Date</label>
                            <input type="date" class="form-control" v-model="newPackage.date" />
                        </div>
    
                        <div class="col-md-6 mb-3">
                            <label>Time</label>
                            <input type="time" class="form-control" v-model="newPackage.time" />
                        </div>
    
                        <div class="col-12 mb-3">
                            <label>Description</label>
                            <tinymce id="d1" v-model="newPackage.description" style="height: 300px" placeholder="Enter description here" class="mb-2" :init="{
                        height: 300,
                        menubar: false,
                        entity_encoding: 'raw', // Important for emoji
                        content_style: `body {
                          font-family: 'Segoe UI Emoji', 'Apple Color Emoji', 'Noto Color Emoji', sans-serif;
                        }`,
                      }"></tinymce>
                        </div>
    
                        <div class="col-12 mt-4">
                            <div class="alert alert-info py-2 px-3 mb-3" role="alert" style="font-size: 14px;">
                                📌 <strong>Note:</strong> Only for <strong>Pakej</strong> or <strong>Bengkel</strong> can add course.
                            </div>
    
                            <div class="row mb-3">
                                <div class="col-md-6">
                                    <!-- <input v-model="newCourse.name" class="form-control" placeholder="Course Name" /> -->
                                    <label>Add Course</label>
                                    <select class="form-control" v-model="newCourse.subjectId" @change="onCourseChange">
                                                    <option disabled value="">Select Course</option>
                                                    <option v-for="course in courseNameOptions" :key="course.value" :value="course.value">
                                                        {{ newPackage.name }} -   {{ course.label }}
                                                    </option>
                                                    <option value="__new__">+ Add New Course</option>
                                                    </select>
                                </div>
                                <div class="col-md-6">
                                    <label>Start Date</label>
                                    <input v-model="newCourse.date" type="date" class="form-control" />
                                </div>
                                <div class="col-md-6 mt-2">
                                    <label>Start Time</label>
                                    <input v-model="newCourse.startTime" type="time" class="form-control" />
                                </div>
                                <div class="col-md-6 mt-2">
                                    <label>End Time</label>
                                    <input v-model="newCourse.endTime" type="time" class="form-control" />
                                </div>
    
                                <div class="col-md-6 mt-3">
                                    <label>Price</label>
                                    <input v-model="newCourse.price" type="text" class="form-control" placeholder="Price Course" />
                                </div>
                                <div class="col-md-6 mt-5">
                                    <input v-model="newCourse.isShow" type="checkbox" class="mr-2" /> Is able to click on sub package
                                </div>
    
                                <div class="col-12 mt-4">
                                    <div class="alert alert-info py-2 px-3 mb-3" role="alert" style="font-size: 14px;">
                                        📌 <strong>Note:</strong> Upload <strong>Module</strong>
                                    </div>
    
                                    <div class="mb-3 border border-dashed rounded p-4 text-center">
                                        <div><i class="bi bi-upload" style="font-size: 24px;"></i></div>
                                        <p class="mb-2">Choose a file or drag & drop it here</p>
                                        <p class="text-muted">PDF, DOCX, ZIP or other ebook formats, up to 20 MB</p>
    
                                        <!-- hidden input -->
                                        <input type="file" class="d-none" ref="fileInputModule" @change="handleFileModule" />
    
                                        <!-- trigger hidden input -->
                                        <button class="btn btn-outline-secondary" @click="$refs.fileInputModule.click()">
          Browse File
        </button>
    
                                        <!-- preview -->
                                        <div v-if="pdfPreviewModule" class="mt-3 text-muted">
                                            <embed :src="pdfPreviewModule" type="application/pdf" width="100%" height="400px" />
                                        </div>
                                    </div>
                                </div>
    
                            </div>
                            <button class="btn btn-sm btn-primary mb-3" @click="addCourse">Add Course</button>
    
                            <table class="table table-outline">
                                <thead>
                                    <tr>
                                        <th>Course Name</th>
                                        <th>Date</th>
                                        <th>Time</th>
                                        <th>Price</th>
                                        <th>Discount</th>
                                        <th>Module</th>
                                        <th style="width: 120px;">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(course, index) in courses" :key="index">
                                        <td>
                                            <span v-if="!course.editing">{{ course.name }}</span>
                                            <select v-else class="form-control form-control-sm" v-model="course.subjectId" @change="onEditCourseSubjectChange(course)">
                                                        <option disabled value="">Select Subject</option>
                                                        <option v-for="subject in courseNameOptions" :key="subject.value" :value="subject.value">
                                                           {{ subject.label }}
                                                        </option>
                                                        </select>
                                        </td>
                                        <td>
                                            <span v-if="!course.editing">{{ course.date }}</span>
                                            <input v-else type="date" v-model="course.date" class="form-control form-control-sm" />
                                        </td>
                                        <td>
                                            <span v-if="!course.editing">{{ course.startTime }} - {{ course.endTime }}</span>
                                            <div v-else class="d-flex gap-1">
                                                <input type="time" v-model="course.startTime" class="form-control form-control-sm" />
                                                <input type="time" v-model="course.endTime" class="form-control form-control-sm" />
                                            </div>
                                        </td>
                                        <td>
                                            <span v-if="!course.editing">{{ course.price }}</span>
                                            <input v-else type="text" v-model="course.price" class="form-control form-control-sm" placeholder="Price" />
                                        </td>
                                        <td>
                                            <span v-if="!course.editing">{{ course.discount }}</span>
                                            <input v-else type="text" v-model="course.discount" class="form-control form-control-sm" placeholder="Discount" />
                                        </td>
                                        <td>
  <!-- Edit mode: show file upload -->
  <div v-if="course.editing">
    <input type="file" @change="onModuleChange($event, index)" />
    <div v-if="course.moduleFile">
      <span>{{ course.moduleFile.name }}</span>
    </div>
  </div>

  <!-- View mode: show filename/link -->
  <div v-else>
    <a v-if="course.moduleFilePath" :href="getFileUrl(course.moduleFilePath)" target="_blank">
      {{ course.moduleFileName || 'View File' }}
    </a>
    <span v-else>-</span>
  </div>
</td>
                                        <td>
                                            <button class="btn btn-sm btn-outline-secondary me-1 mr-2" @click="toggleEditCourse(index)">
                                                    {{ course.editing ? 'Save' : 'Edit' }}
                                                  </button>
                                            <button class="btn btn-sm btn-outline-danger" @click="deleteCourse(index)">Delete</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
    
                            <div class="container mt-4">
                                <h3>Pilih Tahap</h3>
    
                                <div>
                                    <div v-for="(grade, index) in datagrade" :key="'main-' + index" class="form-check form-check-inline">
                                        <input type="radio" class="form-check-input" :id="'main-grade-' + grade.Id" :value="grade" v-model="selectedGrade" @change="ListSubDataGrade(grade.Id)" name="mainGrade" />
                                        <label class="form-check-label" :for="'main-grade-' + grade.Id">
                                        {{ grade.Name }}
                                    </label>
                                    </div>
                                </div>
                                <hr />
    
                                <!-- Sub Grade (Radio Buttons) -->
                                <div v-for="(sub, index) in subdatagrade" :key="'sub-' + index" class="form-check">
                                    <input type="radio" class="form-check-input" :id="'sub-grade-' + sub.Id" :value="sub" v-model="selectedSubGrade" name="subGrade" />
                                    <label class="form-check-label" :for="'sub-grade-' + sub.Id">
                                {{ sub.Name }}
                            </label>
                                </div>
    
    
    
                                <button class="btn btn-success mt-3" @click="saveGrades">Save Selected</button>
    
                                <!-- Table -->
                                <table class="table table-bordered mt-4">
                                    <thead>
                                        <tr>
                                            <th>No</th>
                                            <th>Grade</th>
                                            <th>Sub Grade</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, index) in savedGrades" :key="index">
                                            <td>{{ index + 1 }}</td>
                                            <td>{{ row.gradeName }}</td>
                                            <td>{{ row.subGradeName }}</td>
                                            <td>
                                                <button class="btn btn-sm btn-danger" @click="deleteRow(index)">Delete</button>
                                            </td>
                                        </tr>
                                        <tr v-if="savedGrades.length === 0">
                                            <td colspan="4" class="text-center">No data saved</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
    
                        <!-- Ebook Upload -->
                        <div class="col-12 mt-4">
                            <div class="alert alert-info py-2 px-3 mb-3" role="alert" style="font-size: 14px;">
                                📌 <strong>Note:</strong> Only for <strong>Ebook</strong> can upload file ebook.
                            </div>
                            <div class="mb-3 border border-dashed rounded p-4 text-center">
                                <div><i class="bi bi-upload" style="font-size: 24px;"></i></div>
                                <p class="mb-2">Choose a file or drag & drop it here</p>
                                <p class="text-muted">PDF, DOCX, ZIP or other ebook formats, up to 20 MB</p>
                                <input type="file" class="form-control d-none" ref="fileInputEbook" @change="handleFileEbook" />
                                <button class="btn btn-outline-secondary" @click="$refs.fileInputEbook.click()">Browse File</button>
    
                                <!-- ✅ Show file name -->
                                <div v-if="pdfPreviewEbook" class="mt-3 text-muted">
                                    <embed v-if="pdfPreviewEbook" :src="pdfPreviewEbook" type="application/pdf" width="100%" height="400px" />
                                </div>
                            </div>
                        </div>
    
                        <div class="col-md-6 mb-3">
                            <label>Price</label>
                            <input type="number" class="form-control" v-model="newPackage.price" />
                        </div>
    
                        <div class="col-md-6 mb-3">
                            <label>Discount</label>
                            <input type="number" class="form-control" v-model="newPackage.discount" />
                        </div>
                    </div>
    
                    <!-- Buttons -->
                    <CAlert v-if="Error" color="danger" dismissible @close="Error = false">
                        {{ Message }}
                    </CAlert>
                    <div class="text-right mt-3">
                        <button class="btn btn-secondary me-2" @click="closeModal">Cancel</button>
                        <button class="btn btn-primary ml-2" @click="SubmitProduct">{{ lblBtn }}</button>
                    </div>
                </div>
            </div>
        </CCard>
    
        <CModal title="Delete Product" size="md" :show.sync="showDeleteModal">
            <div class="text-center">
                <img src="../assets/img/deletevector.png" style="max-width:70%" class="mb-2" />
                <br /> Are you sure you want to delete <strong><b>{{ packageName }}</b></strong>?
    
            </div>
            <template #footer>
            <CButton class="p-2 mr-2" color="secondary" @click="showDeleteModal = false">Cancel</CButton>
            <CButton class="p-2" color="danger" @click="deleteItem(deleteItemId)">Delete</CButton>
</template>

</CModal>

    </div>
</template>

<script>
import Vue from "vue";

import _ from "lodash";
import tinymce from "vue-tinymce-editor";
Vue.component("tinymce", tinymce);

export default {
    name: "SkillTable",
    data() {
        return {
            currentPage: 1,
            perPage: 5,
            items: [],
            searchQuery: '',
            showAddModal: false,
            newPackage: {
                id: '',
                name: '',
                title: '',
                students: '',
                date: '',
                time: '',
                description: '',
                price: '',
                discount: ''
            },
            selectedFile: null,
            lblBtn: "Add",
            Error: false,
            Message: "",
            isEditing: false,
            editId: null,
            imagePreview: null,
            courses: [],
            newCourse: {
                id: "",
                subjectId: '',
                date: '',
                startTime: '',
                endTime: '',
                price: '',
                discount: 0,
                isShow: true,
            },
            pdfPreviewEbook: null,
            pdfPreviewModule: null,
            ebookFileName: '',
            courseNameOptions: [],
            customCourseName: '',
            showNewCourseInput: false,

            packageNameOptions: [],
            tableoutline: "",
            packageName: '',
            showDeleteModal: false,
            deleteItemId: 0,
            datagrade: [],
            selectedGrades: [],
            subdatagrade: [],
            selectedSubGrade: [],
            savedGrades: [],
            selectedGrade: "",

            // helper vars for ebook/module inputs
            selectedEbook: null,
            selectedModule: null
        };
    },
    mounted() {

        this.GetListProduct();
        this.GetPackage();
        window.addEventListener('focus', this.handleWindowFocus);
        this.ListGrade();

    },
    computed: {
        filteredItems() {
            const query = (this.searchQuery || '').toLowerCase();
            return this.items.filter(item => {
                return (
                    (item.name || '').toLowerCase().includes(query) ||
                    (item.Title || '').toLowerCase().includes(query) ||
                    (item.Description || '').toLowerCase().includes(query)
                );
            });
        },
        totalPages() {
            return Math.ceil(this.filteredItems.length / this.perPage);
        },
        paginatedItems() {
            const start = (this.currentPage - 1) * this.perPage;
            return this.filteredItems.slice(start, start + this.perPage);
        }
    },
    beforeDestroy() {
        window.removeEventListener('focus', this.handleWindowFocus);

    },
    watch: {
        selectedPackage(newVal) {
            if (newVal && newVal.value) {
                this.newPackage.id = newVal.value;
                this.loadSubjectList(newVal.value);
            }
        }
    },
    methods: {
        handleWindowFocus() {
            this.GetSubject(); // Refresh the list when user comes back
            this.GetPackage();
        },
        deleteItem(id) {
            const formData = new FormData();
            formData.append("packageId", id);

            return this.$API
                .post(this.$UpdateStatusProduct, formData, { withCredentials: true })
                .then((response) => {
                    if (response.status == 200) {
                        this.GetListProduct();
                        this.items = this.items.filter(item => item.id !== id);
                        this.showDeleteModal = false;
                        this.$dialog.alert("Product deleted successfully.");
                    } else {
                        console.log("Error Deleting");
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        changePage(page) {
            if (page >= 1 && page <= this.totalPages) {
                this.currentPage = page;
            }
        },
        closeModal() {
            this.showAddModal = false;
            this.resetForm();
            this.isEditing = false;
            this.editId = null;
            this.lblBtn = "Add";
            this.imagePreview = null;
            this.ebookFileName = '';
        },
        GetListProduct() {
            this.$API.get(this.$GetListProduct)
                .then(response => {
                    if (response.status === 200 && response.data) {
                        this.items = response.data;
                    }
                })
                .catch(error => {
                    console.error("Error fetching products:", error);
                });
        },

        resetForm() {
            this.newPackage = {
                name: '',
                students: '',
                date: '',
                time: '',
                description: '',
                price: '',
                discount: 0
            };

            this.courses = [];
            this.newCourse = {
                name: '',
                date: '',
                time: '',
                price: '',
                discount: 0
            };
            this.selectedFile = null;


            this.selectedEbook = null;
            this.selectedModule = null;
            this.pdfPreviewEbook = null; // <-- Clear preview
            this.pdfPreviewModule = null;
            this.ebookFileName = '';
            this.moduleFileName = '';

            // Also clear the file input
            if (this.$refs.fileInputEbook) {
                this.$refs.fileInputEbook.value = '';
            }

            // Also clear the file input
            if (this.$refs.fileInputModule) {
                this.$refs.fileInputModule.value = '';
            }


            //clear module


            this.selectedGrade = null;
            this.selectedSubGrade = null;
            this.subdatagrade = [];
            this.savedGrades = [];
        },
        handleFile(event) {
            const file = event.target.files[0];
            if (file) {
                this.selectedFile = file;

                const reader = new FileReader();
                reader.onload = (e) => {
                    this.imagePreview = e.target.result;
                };
                reader.readAsDataURL(file);
            }
        },
        handleFileEbook(event) {
            const file = event.target.files[0];
            this.selectedEbook = file;

            if (file && file.type === 'application/pdf') {
                this.pdfPreviewEbook = URL.createObjectURL(file);
            } else {
                this.pdfPreviewEbook = null;
            }
        },
        handleFileModule(e) {
            const file = e.target.files[0];
            if (!file) return;

            this.newCourse.moduleFile = file; // ✅ attach file to course
            this.newCourse.moduleFileName = file.name;

            // optional: generate PDF preview
            if (file.type === "application/pdf") {
                this.pdfPreviewModule = URL.createObjectURL(file);
            } else {
                this.pdfPreviewModule = null;
            }
        },
        // When selecting module for "newCourse" input

        // Single editItem implementation (fixed)
        editItem(item) {
            this.resetForm();
            this.showAddModal = true;
            this.isEditing = true;
            this.editId = item.ID;

            const selectedPackage = this.packageNameOptions.find(
                (p) => p.value === item.PackageId
            );

            this.originalPackageName = item.Title || (selectedPackage && selectedPackage.label) || "";

            this.newPackage = {
                id: item.TuitionPackageId || "",
                name: item.Title || (selectedPackage && selectedPackage.label) || "Untitled Package",
                title: item.Title || (selectedPackage && selectedPackage.label) || "Untitled Package",
                students: item.NoOfStudent,
                date: item.DateCourse ? item.DateCourse.split("T")[0] : null,
                time: item.TimeCourse,
                description: item.Description,
                price: item.TotalPrice || item.Price || 0,
                discount: item.Discount || 0
            };

            this.selectedFile = null;
            this.lblBtn = "Update";

            const scheduleMap = {};
            (item.ScheduleClass || []).forEach(s => {
                scheduleMap[s.TuitionSubjectId] = s;
            });

            this.courses = (item.ProductClass || []).map((c, i) => {
    const schedule = scheduleMap[c.TuitionSubjectId];

    return {
        name: c.CourseName,
        subjectId: c.TuitionSubjectId,
        date: c.Date ? c.Date.split("T")[0] : null,
        time: c.Time || '',
        price: c.Price,
        discount: c.Discount,
        startTime: schedule && schedule.ScheduleDateTime ? schedule.ScheduleDateTime.substring(11, 16) : (c.StartTime || ''),
        endTime: schedule && schedule.ScheduleDateTimeEnd ? schedule.ScheduleDateTimeEnd.substring(11, 16) : (c.EndTime || ''),
        editing: false,
        isShow: c.IsShow !== undefined ? c.IsShow : true,

        // ✅ Existing file info
        moduleFile: null,               // will be used if user uploads new file
        moduleFileName: c.ModuleFileName || null, // display name
        moduleFilePath: c.ModuleFilePath || null, // backend path
        moduleFileId: c.ModuleFileId || null      // backend ID

        // Optional: generate preview for PDF
        // pdfPreview: c.ModuleFilePath ? this.getFileUrl(c.ModuleFilePath) : null
    };
});

            this.$nextTick(() => {
                if (window.tinymce) {
                    const editor = tinymce.get('d1');
                    if (editor) {
                        editor.setContent(this.newPackage.description || '');
                    }
                }
            });
            const packageId = this.newPackage.id;
            // Call GetSubject with selected packageId
            this.GetSubject(packageId);

            this.fetchSavedGrades(item.ID);
        },
        SubmitProduct() {
            const finalTitle = this.isEditing && this.newPackage.name === this.originalPackageName ?
                this.originalPackageName :
                this.newPackage.name;


            this.lblBtn = this.isEditing ? "Updating..." : "Processing";
            this.Error = false;

            console.log("newPackage", this.newPackage);
            console.log("finalTitle", finalTitle);

            const formData = new FormData();
            formData.append("title", finalTitle);
            formData.append("name", finalTitle);
            formData.append("description", this.newPackage.description);
            formData.append("totalPrice", this.newPackage.price);
            formData.append("discount", this.newPackage.discount);
            formData.append("productId", this.isEditing ? this.editId : 0);
            formData.append("dateCourse", this.newPackage.date);
            formData.append("noOfStudent", this.newPackage.students);
            formData.append("timeCourse", this.newPackage.time);
            formData.append("isLooseItem", this.courses.length > 0 ? true : false);
            // formData.append("courseList", JSON.stringify(this.courses));
            formData.append("tuitionPackageId", this.newPackage.id);
            if (this.savedGrades && this.savedGrades.length > 0) {
                formData.append("grades", JSON.stringify(this.savedGrades));
            }
           // ✅ Prepare courseList with keys for module files
           const courseListWithKeys = this.courses.map((c, i) => {
  const copy = { ...c };

  if (c.moduleFile) {
    // New upload
    copy.moduleFileKey = `moduleFile_${i}`;
    formData.append(copy.moduleFileKey, c.moduleFile);
  } else {
    // Existing or no file
    copy.moduleFileKey = ""; // ✅ always send this
    copy.moduleFileId = c.moduleFileId || null;
  }

  delete copy.moduleFile; // don't send raw File
  return copy;
});

formData.append("courseList", JSON.stringify(courseListWithKeys));




            if (this.selectedFile) {
                formData.append("image", this.selectedFile);
            }
            if (this.selectedEbook) {
                formData.append("ebook", this.selectedEbook);
            }

            this.$API.post(this.$UploadNewProduct, formData, {
                    withCredentials: true,
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    if (response.status === 200) {
                        this.resetForm();
                        this.GetListProduct();
                        this.lblBtn = "Success";
                        alert(this.isEditing ? "Updated successfully!" : "Successfully added new product!");
                        this.closeModal();


                    } else {
                        this.lblBtn = "Add";
                        this.Error = true;
                        this.Message = "Failed to upload product.";
                    }
                })
                .catch((error) => {
                    this.lblBtn = "Add";
                    this.Error = true;
                    this.Message = error.response ?.data || "An unexpected error occurred.";
                });
        },
        addCourse() {
  if (
    this.newCourse.subjectId &&
    this.newCourse.date
  ) {
    const subject = this.courseNameOptions.find(s => s.value === this.newCourse.subjectId);

    if (!subject) {
      alert("Selected subject not found.");
      return;
    }

    const startDateTime = `${this.newCourse.date}T${this.newCourse.startTime}:00`;
    const endDateTime = `${this.newCourse.date}T${this.newCourse.endTime}:00`;

    this.courses.push({
      subjectId: this.newCourse.subjectId,
      name: subject.label,
      date: this.newCourse.date,
      time: this.newCourse.startTime,
      startTime: this.newCourse.startTime,
      endTime: this.newCourse.endTime,
      startDateTime,
      endDateTime,
      price: this.newCourse.price,
      discount: this.newCourse.discount || 0,
      editing: false,
      isShow: this.newCourse.isShow !== undefined ? this.newCourse.isShow : true,

      // ✅ keep existing file if no new file is uploaded
      moduleFile: this.newCourse.moduleFile || null,
      moduleFileKey: this.newCourse.moduleFileKey || "", 
      moduleFilePath: this.newCourse.moduleFilePath || "",
      moduleFileName: this.newCourse.moduleFileName || "",
    });

    // Reset form (don’t clear file info, only reset input fields)
    this.newCourse = {
      subjectId: '',
      date: '',
      time: '',
      price: '',
      discount: '',
      isShow: true,
      moduleFile: null,
      moduleFileKey: "",
      moduleFilePath: "",
      moduleFileName: "",
    };
  }
},
        toggleEditCourse(index) {
            const course = this.courses[index];

            if (course.editing) {
                // Ensure subjectId is not lost
                if (!course.subjectId) {
                    alert('Subject ID is missing. Please re-select the subject.');
                    return;
                }

                course.editing = false;
            } else {
                course.editing = true;
            }
        },
        deleteCourse(index) {
            this.courses.splice(index, 1);
        },
        addNewCourseName() {
            if (!this.customCourseName.trim()) return;

            this.courseNameOptions.push(this.customCourseName.trim());
            this.newCourse.name = this.customCourseName.trim();
            this.customCourseName = '';
        },
        onCourseChangePackage() {
            if (this.newPackage.id === '__new__') {
                window.open(`${window.location.origin}/#/TuitionPackage`, '_blank');
                this.newPackage.id = ''; // Reset the selection
                return;
            }
            const selected = this.packageNameOptions.find(p => p.value === this.newPackage.id);
            if (selected) {
                this.newPackage.name = selected.label;
            }

            const packageId = this.newPackage.id;
            // Call GetSubject with selected packageId
            this.GetSubject(packageId);


        },
        GetSubject(packageId) {
            this.Busy = true;
            this.$API
                .get(this.$ListSubjectPerPackage + "?packageId=" + packageId, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.Busy = false;
                        this.courseNameOptions = response.data.map(item => ({
                            label: item.SubjectName,
                            value: item.SubjectId
                        }));
                    }
                });
        },
        onCourseChange() {
            if (this.newCourse.subjectId === '__new__') {
                window.open(`${window.location.origin}/#/TuitionSubject`, '_blank');
                this.newCourse.subjectId = ''; // Reset the selection
            }
        },

        GetPackage() {
            this.Busy = true;
            this.$API
                .get(this.$ViewPackage, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.Busy = false;
                        this.packageNameOptions = response.data.map(item => ({
                            label: item.Name,
                            value: item.Id
                        }));

                    }
                });
        },
        onEditCourseSubjectChange(course) {
            const selected = this.courseNameOptions.find(s => s.value === course.subjectId);
            if (selected) {
                course.name = selected.label;
            }
        },
        loadSubjectList(packageId) {
            if (!packageId || packageId === "undefined") {
                console.warn("Invalid packageId to load subjects");
                return;
            }

            this.$API
                .get(this.$ListSubjectPerPackage + "?packageId=" + packageId, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status === 200) {
                        this.courseList = response.data.map(subject => ({
                            name: subject.name,
                            subjectId: subject.subjectId,
                            date: subject.date,
                            time: subject.time,
                            price: subject.price,
                            discount: subject.discount,
                            startTime: subject.startTime,
                            endTime: subject.endTime,
                            editing: false,
                            isShow: true,
                            moduleFileName: subject.moduleFileName,
                            moduleFilePath: subject.ModuleFilePath
                        }));
                    }
                })
                .catch((err) => {
                    console.error("Error loading subjects", err);
                    this.courseList = [];
                });
        },
        OpenDelete(item) {
            if (item) {
                this.deleteItemId = Number(item.ID); // normalize id
                this.packageName = item.Title ?? item.PackageName ?? "";
                this.showDeleteModal = true;

                console.log("OpenDelete ->", this.deleteItemId, this.packageName);
            }
        },
        ListGrade() {
            this.$API
                .get(this.$GetListGradePackage)
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.Busy = false;
                        this.datagrade = response.data;
                    }
                });
        },
        ListSubDataGrade(id) {
            this.$API
                .get(this.$GetListSubGradePackage + "?gradeId=" + id)
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.Busy = false;
                        this.subdatagrade = response.data;
                    }
                });
        },
        saveGrades() {
            if (!this.selectedGrade || !this.selectedSubGrade) {
                alert("Please select both grade and sub grade!");
                return;
            }

            this.savedGrades.push({
                gradeId: this.selectedGrade.Id,
                gradeName: this.selectedGrade.Name,
                subGradeId: this.selectedSubGrade.Id,
                subGradeName: this.selectedSubGrade.Name
            });

            // optional: reset radio after saving
            this.selectedGrade = null;
            this.selectedSubGrade = null;
            this.subdatagrade = [];
        },
        async deleteRow(index) {
            const row = this.savedGrades[index];

            // If row came from API (has DB Id), call backend delete
            if (row.Id) {
                try {
                    const formData = new FormData();
                    formData.append("gradeListId", row.Id);

                    const response = await this.$API.post(this.$DeleteListGrade, formData);

                    if (response.status === 200) {
                        console.log("Successfully deleted from DB");
                        this.savedGrades.splice(index, 1); // remove locally
                    } else {
                        console.error("Error deleting from DB");
                    }
                } catch (error) {
                    console.error("Delete API error:", error);
                }
            } else {
                // If row is only frontend (not saved yet), just remove
                this.savedGrades.splice(index, 1);
            }
        },
        editRow(index) {
            const row = this.savedGrades[index];
            this.selectedGrade = { Id: row.gradeId, Name: row.gradeName };
            this.ListSubDataGrade(row.gradeId);
            this.selectedSubGrade = { Id: row.subGradeId, Name: row.subGradeName };
            this.savedGrades.splice(index, 1); // remove old entry so after save it will be updated
        },
        async fetchSavedGrades(id) {
            try {
                const response = await this.$API.get(
                    this.$GetListProductGradeSubGrade + "?productId=" + id
                );

                if (response.status === 200) {
                    // API already returns correct shape
                    this.savedGrades = response.data;
                }
            } catch (err) {
                console.error("Error fetching grades:", err);
            }
        },
        onModuleChange(event, index) {
    const file = event.target.files[0];
    if (file) {
        Vue.set(this.courses[index], "moduleFile", file);
        Vue.set(this.courses[index], "moduleFileName", file.name);
    }
},
        getFileUrl(path) {
    if (!path) return "#";
    return path.startsWith("http")
      ? path
      : `https://flyhighfiles.s3.ap-southeast-5.amazonaws.com/${path}`;
  }

    }
};
</script>

<style scoped>
.table-outline {
    border-collapse: collapse;
    width: 100%;
    border: 1px solid #ccc;
    /* outer border */
}

.table-outline td,
.table-outline th {
    border: none;
    /* remove inner borders */
    padding: 8px;
}

.table-outline tr:first-child th {
    border-bottom: 1px solid #ccc;
    /* optional: bottom border for header */
}
</style>
